export default {
  textRepl: function textRepl(str) {
    var reple = process.env.VUE_APP_IMAGEURLRPLE;
    var url = process.env.VUE_APP_IMAGEURL;
    console.log(reple);
    console.log(url);
    var newstr = str.replaceAll(reple, url + reple);
    console.log(newstr);
    return newstr;
  },
  imgTrow: function imgTrow(str) {
    var url = process.env.VUE_APP_IMAGEURL;
    return url + str;
  }
};